import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { verifyEmail } from '../api/apiClient';

const VerifyEmailPage = () => {
  const [message, setMessage] = useState('Verifying your email, please wait...');
  const [isSuccess, setIsSuccess] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token');
    if (!token) {
      setMessage('Verification token not found in URL.');
      return;
    }
    
    const doVerify = async () => {
      try {
        const response = await verifyEmail(token);
        setMessage(response.message || 'Email successfully verified!');
        setIsSuccess(true);
      } catch (err) {
        setMessage(err.message || 'Failed to verify email.');
      }
    };
    doVerify();
  }, [location]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-900">
      <div className="w-full max-w-md p-8 text-center bg-slate-800 rounded-2xl shadow-lg">
        <h1 className="text-3xl font-bold text-white">Email Verification</h1>
        <p className={`mt-4 text-lg ${isSuccess ? 'text-green-400' : 'text-red-400'}`}>
          {message}
        </p>
        {isSuccess && (
          <Link to="/login" className="mt-6 inline-block w-full py-3 px-4 font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700">
            Proceed to Sign In
          </Link>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;